import { render } from "./ServicesTemplate.vue?vue&type=template&id=415932a5"
import script from "./ServicesTemplate.vue?vue&type=script&lang=js"
export * from "./ServicesTemplate.vue?vue&type=script&lang=js"

import "./ServicesTemplate.vue?vue&type=style&index=0&id=415932a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__